import React, { useState, useEffect } from "react";
import { translate } from "react-i18next";
import { types } from "../Details/voteTypes";

import {
  Container,
  Response,
  Responses,
  Collapse,
  Buttons,
  Button,
  Expand
} from "./styles";

function MultiRequestors({ lang, responses, t }) {
  const [collapseList, setCollapseList] = useState([]);
  useEffect(() => {
    let arr = [];

    for (let i = 0; i < responses.result.length; i++) {
      arr.push({ isExpanded: false });
    }

    setCollapseList(...collapseList, arr);
  }, []);

  function renderLabel(type, response) {
    switch (type) {
      case 1:
        const satisfaction = types.satisfaction.find(el => {
          if (response === el.response) return el.Label;
        });

        return returnComponent(satisfaction);

      case 2:
        const smiles = types.smiles.find(el => {
          if (response === el.response) return el.Label;
        });

        return returnComponent(smiles);

      case 3:
        const nps = types.NPS.find(el => {
          if (response === el.response) return el.Label;
        });
        return returnComponent(nps);
      case 4:
        const yesNo = types.yesNo.find(el => {
          if (response === el.response) return el.Label;
        });

        return returnComponent(yesNo);

      default:
        return;
    }
  }

  function returnComponent({ Label, color, description }) {
    return color ? <Label bgColor={color}>{t(description)}</Label> : Label;
  }

  function handleRenderDescription(languages) {
    let currLang;

    currLang = languages.find(({ language }) => {
      return language.substring(0, 2) === lang;
    });

    if (!!currLang) {
      return currLang.description;
    } else {
      return languages[0].description;
    }
  }

  function expandAll(e) {
    e.preventDefault();
    const arr = collapseList;

    setCollapseList([...collapseList, arr.map(el => (el.isExpanded = true))]);
  }

  function closeAll(e) {
    e.preventDefault();
    const arr = collapseList;

    setCollapseList([...collapseList, arr.map(el => (el.isExpanded = false))]);
  }

  function collapse(context) {
    let arr = collapseList;
    arr[context].isExpanded = !arr[context].isExpanded;

    setCollapseList([...collapseList, arr]);
  }

  return (
    <Container>
      <Buttons>
        <Button onClick={e => expandAll(e)}>{t("expandAll")}</Button>
        <Button onClick={e => closeAll(e)}>{t("closeAll")}</Button>
      </Buttons>
      {responses.result.map((client, index) => (
        <Response key={index}>
          <div className="name-container">
            <p>
              {t("ratingOf", {
                name: client.clientName
              })}
            </p>
            {collapseList.length && (
              <div onClick={() => collapse(index)}>
                {collapseList[index].isExpanded ? <Collapse /> : <Expand />}
              </div>
            )}
          </div>
          {collapseList.length && collapseList[index].isExpanded && (
            <div>
              <hr />
              {client.responses.map((response, index) => (
                <Responses key={index}>
                  <p className="marginb">
                    {handleRenderDescription(response.languages)}
                  </p>
                  <label>{renderLabel(response.type, response.response)}</label>
                  <h6>{t("comment")}</h6>
                  <p>{response.commentary}</p>

                  <p className="marginb date">{response.responseDate}</p>
                </Responses>
              ))}
            </div>
          )}
        </Response>
      ))}
    </Container>
  );
}

export default translate("translations")(MultiRequestors);
